import { CONFIG, type Outcome, type RiskTier } from '@h2h/shared';

export const BASE = CONFIG.COMBO.BASE_POINTS;

/** Risk-tier accent (Safe green, Medium amber, Bold "legendary" orange). Red is
 *  deliberately NOT a tier — it's reserved across the builder for loss/bust
 *  (a missed boost, the −BASE downside), so the tiers can escalate in heat
 *  without clashing with the "this goes negative" signal. */
export const TIER_COLOR: Record<RiskTier, string> = {
  SAFE: '#11B36B',
  MEDIUM: '#E3A82B',
  BOLD: '#F5600F'
};

export const TIER_TEXT: Record<RiskTier, string> = {
  SAFE: '#fff',
  MEDIUM: '#3A2A00',
  BOLD: '#fff'
};

/** The shared "loss" red — a missed boost / busted base. Never a tier colour. */
export const LOSS_RED = '#EF4135';

/** 1X2 base label relative to the two team codes. */
export function outcomeWord(o: Outcome | null, home: string, away: string): string {
  if (o === 'HOME') return home;
  if (o === 'AWAY') return away;
  if (o === 'DRAW') return 'Draw';
  return '—';
}
